import { ImageRatio } from '@synergy/models';

export const getWidthByRatio = (imageRatio: ImageRatio, height: number) => height / imageRatio;
export const getHeightByRatio = (imageRatio: ImageRatio, width: number) => width / imageRatio;
